import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthlyBtn", "annualBtn",
    "proMonthly", "proAnnual", "proPeriod",
    "starterMonthly", "starterAnnual", "starterPeriod",
    "coachMonthly", "coachAnnual", "coachPeriod"
  ]

  selectMonthly() {
    this.monthlyBtnTarget.style.background = "rgba(255,255,255,0.1)"
    this.monthlyBtnTarget.style.color = "#fff"
    this.annualBtnTarget.style.background = "transparent"
    this.annualBtnTarget.style.color = "rgba(255,255,255,0.4)"
    this.monthlyBtnTarget.setAttribute("aria-pressed", "true")
    this.annualBtnTarget.setAttribute("aria-pressed", "false")

    this.proMonthlyTarget.style.display = ""
    this.proAnnualTarget.style.display = "none"
    this.proPeriodTarget.textContent = "Billed monthly"

    this.starterMonthlyTarget.style.display = ""
    this.starterAnnualTarget.style.display = "none"
    this.starterPeriodTarget.textContent = "Billed monthly"

    this.coachMonthlyTarget.style.display = ""
    this.coachAnnualTarget.style.display = "none"
    this.coachPeriodTarget.textContent = "Billed monthly"
  }

  selectAnnual() {
    this.annualBtnTarget.style.background = "rgba(255,255,255,0.1)"
    this.annualBtnTarget.style.color = "#fff"
    this.monthlyBtnTarget.style.background = "transparent"
    this.monthlyBtnTarget.style.color = "rgba(255,255,255,0.4)"
    this.annualBtnTarget.setAttribute("aria-pressed", "true")
    this.monthlyBtnTarget.setAttribute("aria-pressed", "false")

    this.proMonthlyTarget.style.display = "none"
    this.proAnnualTarget.style.display = ""
    this.proPeriodTarget.textContent = "Billed annually"

    this.starterMonthlyTarget.style.display = "none"
    this.starterAnnualTarget.style.display = ""
    this.starterPeriodTarget.textContent = "Billed annually"

    this.coachMonthlyTarget.style.display = "none"
    this.coachAnnualTarget.style.display = ""
    this.coachPeriodTarget.textContent = "Billed annually"
  }
}
